import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import useMe from '../../hooks/users/useMe'
import useAnnouncements from '../../hooks/announcements/useAnnouncements'
import PropTypes from 'prop-types'

const PrivateRoute = ({ children }) => {
  const { isStale, refetch: refetchMe, isError, isSuccess: gotMe } = useMe()
  const { isStale: staleAnnouncements, refetch: refetchAnnouncements } = useAnnouncements()

  useEffect(() => {
    if (isStale) {
      refetchMe()
    }
  }, [isStale])

  useEffect(() => {
    if (gotMe) {
      if (staleAnnouncements) {
        refetchAnnouncements()
      }
    }
  }, [gotMe, staleAnnouncements])

  if (isError) {
    return <Navigate to='/login' replace />
  }

  return (
    <>
      {children}
    </>
  )
}

PrivateRoute.propTypes = {
  children: PropTypes.node
}

export default PrivateRoute